import { Link } from "react-router-dom";

const Menu = () => {
  return (
    <>
      <nav>
        <Link
          target={"_blank"}
          to={`https://medium.com/@vestatefund/the-rules-of-vesmap-bd0a58385ecd`}
        >
          Rules
        </Link>
      </nav>
      <nav>
        <Link
          target={"_blank"}
          to={`https://medium.com/@vestatefund/how-do-you-lock-claim-your-tokens-on-vesmap-39b9b65f1e91`}
        >
          Guide
        </Link>
      </nav>
      <nav>
        <Link
          target={"_blank"}
          to={`${process.env.REACT_APP_NETWORKSCAN}address/${process.env.REACT_APP_CONTRACT_ADDRESS}`}
        >
          Contract
        </Link>
      </nav>
      <nav>
        <Link
          target={"_blank"}
          to={`https://coinmarketcap.com/currencies/vestate/`}
        >
          Token Info
        </Link>
      </nav>
    </>
  );
};

export default Menu;
